<template>
	<FormKit
		type="form"
		ref="inputForm"
		v-model="fDInfo"
		:actions="false"
		#default="{ state: { valid, dirty } }"
		form-class="relative"
	>
		<div class="flex w-full gap-4 *:w-full *:max-w-none">
			<FormKit
				type="text"
				name="firstName"
				:placeholder="t('person.firstName')"
				inner-class="text-slate-600"
				validation="required"
				validation-label="First Name"
			/>
			<FormKit
				type="text"
				name="lastName"
				:placeholder="t('person.lastName')"
				inner-class="text-slate-600"
				validation="required"
				validation-label="Last Name"
			/>
			<FormKit
				type="email"
				name="email"
				:placeholder="t('person.email')"
				inner-class="text-slate-600"
				validation="required|email"
				validation-label="Email"
			/>
		</div>
		<div
			v-if="
				fDInfo.firstName === '' || fDInfo.lastName === '' || fDInfo.email === ''
			"
			class="mb-1.5 text-xs text-red-600 dark:text-red-400"
		>
			{{ t('document.submission.invalidSignerError') }}
		</div>
	</FormKit>
</template>

<script setup lang="ts">
import type { SignerInfo } from '@/types'
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const emit = defineEmits(['validity-changed'])

const inputForm = ref()

const fDInfo = defineModel<SignerInfo>({
	required: true,
})

const inputValid = computed(() => {
	return inputForm.value?.node.context.state.valid ?? false
})

watch(
	inputValid,
	(newValue) => {
		emit('validity-changed', newValue)
	},
	{ immediate: true }
)
</script>

<style scoped></style>
